<template>
    <div class="dokan-announcement-wrapper">
        <tabs/>
        <br />
        <h1 class="wp-heading-inline">{{ __( 'Quote Rules', 'dokan' ) }}</h1>
        <router-link :to="{ name: 'NewQuoteRules' }" class="page-title-action">{{ __( 'New Quote Rules', 'dokan' ) }}</router-link>

        <hr class="wp-header-end">

        <ul class="subsubsub">
            <li><router-link :to="{ name: 'RequestAQuoteRules' }" active-class="current" exact >{{ __( 'All', 'dokan' ) }} <span class="count">{{ counts.all }}</span></router-link> | </li>
            <li><router-link :to="{ name: 'RequestAQuoteRules', query: { status: 'publish' }}" active-class="current" exact >{{ __( 'Published', 'dokan' ) }} <span class="count">{{ counts.publish }}</span></router-link> | </li>
            <li><router-link :to="{ name: 'RequestAQuoteRules', query: { status: 'draft' }}" active-class="current" exact >{{ __( 'Draft', 'dokan' ) }} <span class="count">{{ counts.draft }}</span></router-link> | </li>
            <li><router-link :to="{ name: 'RequestAQuoteRules', query: { status: 'trash' }}" active-class="current" exact >{{ __( 'Trash', 'dokan' ) }} <span class="count">{{ counts.trash }}</span></router-link></li>
        </ul>

        <list-table
            :columns="columns"
            :rows="requests"
            :loading="loading"
            :action-column="actionColumn"
            :actions="actions"
            :show-cb="showCb"
            :bulk-actions="bulkActions"
            :not-found="notFound"
            :total-pages="totalPages"
            :total-items="totalItems"
            :per-page="perPage"
            :current-page="currentPage"
            @pagination="goToPage"
            @bulk:click="onBulkAction"
            :text="$root.listTableTexts()"
        >

            <template slot="rule_name" slot-scope="data">
                <strong v-if="'trash' === data.row.status">{{ data.row.rule_name }}</strong>
                <strong v-else><a :href="editUrl(data.row.id)">{{ data.row.rule_name }}</a></strong>
            </template>

            <template slot="status" slot-scope="data">
                <span :class="data.row.status">{{ status[data.row.status] }}</span>
            </template>

            <template slot="created_at" slot-scope="data">
                {{ data.row.created_at }}
            </template>
            <template slot="row-actions" slot-scope="data">
                <template v-for="(action, index) in actions">
                    <span :class="action.key" v-if="action.key === 'edit'">
                        <a :href="editUrl(data.row.id)">{{ action.label }}</a>
                        <template v-if="index !== ( actions.length - 1)"> | </template>
                    </span>
                    <span :class="action.key" v-if="action.key === 'trash' && currentStatus !=='trash'">
                        <a href="#" @click.prevent="rowAction( action.key, data )">{{ action.label }}</a>
                    </span>
                    <span :class="action.key" v-if="action.key === 'delete' && currentStatus === 'trash'">
                        <a href="#" @click.prevent="rowAction( action.key, data )">{{ action.label }}</a>
                        <template v-if="index !== ( actions.length - 1)"> | </template>
                    </span>
                    <span :class="action.key" v-if="action.key === 'restore' && currentStatus === 'trash'">
                        <a href="#" @click.prevent="rowAction( action.key, data )">{{ action.label }}</a>
                        <template v-if="index !== ( actions.length - 1)"> | </template>
                    </span>
                </template>
            </template>
        </list-table>
    </div>
</template>

<script>
import Tabs from '../components/Tabs.vue';
const ListTable = dokan_get_lib('ListTable');
const apiBase = 'request-for-quote/quote-rule';
const moment = dokan_get_lib('moment')
export default {
    name: 'RequestAQuoteRules',

    components: {
        ListTable,
        Tabs,
    },

    data() {
        return {
            requests: [],
            loading: false,
            status: {
                'publish' : this.__( 'Published', 'dokan' ),
                'draft' : this.__( 'Draft', 'dokan' ),
                'trash' : this.__( 'Trash', 'dokan' ),
            },
            counts: {
                all: 0,
                publish: 0,
                draft: 0,
                trash: 0,
            },
            notFound: this.__( 'No quote found.', 'dokan' ),
            totalPages: 1,
            perPage: 10,
            totalItems: 0,
            showCb: true,
            columns: {
                'rule_name'     : { label: this.__( 'Rules', 'dokan' ) },
                'status'        : { label: this.__( 'Status', 'dokan' ) },
                'hide_price'    : { label: this.__( 'Hidden Price', 'dokan' ) },
                'rule_priority' : { label: this.__( 'Priority', 'dokan' ) },
                'created_at'    : { label: this.__( 'Date', 'dokan' ) },
            },
            actionColumn: 'rule_name',
            actions: [
                {
                    key: 'edit',
                    label: this.__( 'Edit', 'dokan' )
                },
                {
                    key: 'trash',
                    label: this.__( 'Trash', 'dokan' )
                },
                {
                    key: 'delete',
                    label: this.__( 'Delete Permanently', 'dokan' )
                },
                {
                    key: 'restore',
                    label: this.__( 'Restore', 'dokan' )
                }
            ],
        }
    },

    watch: {
        '$route.query.status'() {
            this.fetchAll();
        },

        '$route.query.page'() {
            this.fetchAll();
        }
    },

    computed: {
        currentStatus() {
            return this.$route.query.status || 'all';
        },

        currentPage() {
            let page = this.$route.query.page || 1;
            return parseInt( page );
        },

        bulkActions() {
            if ( 'trash' === this.$route.query.status ) {
                return [
                    {
                        key: 'delete',
                        label: this.__( 'Delete Permanently', 'dokan' )
                    },
                    {
                        key: 'restore',
                        label: this.__( 'Restore', 'dokan' )
                    }
                ];
            } else {
                return [
                    {
                        key: 'trash',
                        label: this.__( 'Move to Trash', 'dokan' )
                    },
                ];
            }
        },
        checkLangRtlHelp(){
            return isRtl === 1 && isRtl !== undefined ? 'help-block-rtl': 'help-block-ltr';
        }
    },

    methods: {
        updatedCounts( xhr ) {
            this.counts.all     = parseInt( xhr.getResponseHeader('X-Status-All') );
            this.counts.publish = parseInt( xhr.getResponseHeader('X-Status-Publish') );
            this.counts.draft   = parseInt( xhr.getResponseHeader('X-Status-Draft') );
            this.counts.trash   = parseInt( xhr.getResponseHeader('X-Status-Trash') );
        },

        updatePagination(xhr) {
            this.totalPages = parseInt( xhr.getResponseHeader('X-WP-TotalPages') );
            this.totalItems = parseInt( xhr.getResponseHeader('X-WP-Total') );
        },

        fetchAll() {
            this.loading = true;
            const data = {
                per_page: this.perPage,
                page: this.currentPage,
                status: this.currentStatus,
            };
            dokan.api.get('/'+ apiBase, data)
            .done((response, status, xhr) => {
                this.requests = response;
                this.loading = false;

                this.updatedCounts( xhr );
                this.updatePagination( xhr );
            });
        },

        moment(date) {
            return moment(date);
        },

        editUrl(id) {
            return dokan.urls.adminRoot + 'admin.php?page=dokan#/'+ apiBase +'/' + id + '/edit';
        },

        goToPage(page) {
            this.$router.push({
                name: 'RequestAQuoteRules',
                query: {
                    status: this.currentStatus,
                    page: page
                }
            });
        },

        rowAction( action, data ) {
            if ( ! data.row.id ) {
                alert( this.__( 'No data found', 'dokan' ) );
                return;
            }

            if ( 'trash' === action || 'delete' === action ) {
                this.loading = true;

                var isPermanentDelete = ( 'delete' === action ) ? '?force=true' : '';

                dokan.api.delete('/'+ apiBase +'/' + data.row.id + isPermanentDelete )
                .done( ( response, status, xhr ) => {
                    this.fetchAll();
                    this.loading = false;
                })
                .error( ( response, status, xhr ) => {
                    this.loadSpinner = false;
                    alert( response.responseJSON.message );
                });
            }

            if ( 'restore' === action ) {
                this.loading = true;
                let jsonData = {};

                dokan.api.put('/'+ apiBase +'/' + data.row.id + '/restore' )
                .done( ( response, status, xhr ) => {
                    this.fetchAll();
                    this.loading = false;
                })
                .error( ( response, status, xhr ) => {
                    this.loadSpinner = false;
                    alert( response.responseJSON.message );
                });
            }
        },

        onBulkAction( action, items ) {
            if ( 'trash' === action ) {
                this.loading = true;

                let jsonData = {};
                jsonData.trash = items;

                dokan.api.put('/'+ apiBase +'/batch', jsonData )
                .done( ( response, status, xhr ) => {
                    this.fetchAll();
                    this.loading = false;
                })
                .error( ( response, status, xhr ) => {
                    this.loadSpinner = false;
                    alert( response.responseJSON.message );
                });
            }

            if ( 'delete' === action ) {
                this.loading = true;

                let jsonData = {};
                jsonData.delete = items;

                dokan.api.put('/'+ apiBase +'/batch', jsonData )
                .done( ( response, status, xhr ) => {
                    this.fetchAll();
                    this.loading = false;
                })
                .error( ( response, status, xhr ) => {
                    this.loadSpinner = false;
                    alert( response.responseJSON.message );
                });

            }

            if ( 'restore' === action ) {
                this.loading = true;
                let jsonData = {};
                jsonData.restore = items;

                dokan.api.put('/'+ apiBase +'/batch', jsonData )
                .done( ( response, status, xhr ) => {
                    this.fetchAll();
                    this.loading = false;
                })
                .error( ( response, status, xhr ) => {
                    this.loadSpinner = false;
                    alert( response.responseJSON.message );
                });
            }

        },
    },

    created() {
        this.fetchAll();
    }

};

</script>

<style lang="less">
.dokan-announcement-wrapper {
    position: relative;

    .help-block {
        position: absolute;
        top: 10px;

        span.help-text {
            display: inline-block;
            margin-top: 4px;
            margin-right: 6px;
            a {
                text-decoration: none;
            }
        }

        span.dashicons {
            font-size: 25px;
        }
    }

    th.title {
        width: 35%;
    }

    td.status {
        span {
            line-height: 2.5em;
            padding: 5px 8px;
            border-radius: 4px;
        }

        .publish {
            background: #c6e1c6;
            color: #5b841b;
        }

        .pending {
            background: #f8dda7;
            color: #94660c
        }

        .trash {
            background: #eba3a3;
            color: #761919
        }

        .draft {
            background: #e5e5e5;
            color: #761919
        }

        .future {
            background: #8080805c;
            color: #000000e0;
        }
    }
    .dokan-modal {
        header.modal-header  {
            h1 {
                width: 90%;
            }
        }
    }
    .announcement-modal-content {
        height: 200px;
    }
}

@media only screen and (max-width: 600px) {
    .dokan-announcement-wrapper {
        .help-block {
            top: 45px !important;
            left: 0 !important;
        }

        .subsubsub {
            margin-top: 20px;
        }

        table {
            td.title, td.content {
                display: table-cell !important;
            }

            th:not(.check-column):not(.title):not(.content):not(.send_to) {
                display: none;
            }

            td:not(.check-column):not(.title):not(.content):not(.send_to) {
                display: none;
            }

            th.column, td.column {
                width: auto;
            }

            td.manage-column.column-cb.check-column {
                padding-right: 15px;
            }
            td.selected_user_role{
                word-wrap: break-word;
            }
        }
    }
}
.dokan-settings-wrap .dashicons.dashicons-money-alt {
    color: #ff0099;
}


.help-block-rtl{
    left: 10px;
}
.help-block-ltr{
    right: 10px;
}
</style>
